import React from 'react';
import DashMain from '../../Dashboard/DashMain';
import Navbar from '../Header/Navbar';
import Header from './header/Header';

const Home = () => {
    return (
        <div>
            
          <Header />

        </div>
    );
};

export default Home;